import { FC } from 'react';
import { Box, Divider } from '@chakra-ui/react';

import Button from 'components/_core/Button';

import SelectContactsToSendTo from '../SelectContactsToSendTo';
import locales from './locales';

interface ContactPickerProps {
  clientId: string;
  contactOptions: ContactOptions;
  onChangeContactOptions: (contactOptions: ContactOptions) => void;
  loading: boolean;
  onSendDummy: () => void;
}

export interface ContactOptions {
  isUserCcedOnEmails: boolean;
  clientContactIds: string[];
}

const ContactPicker: FC<ContactPickerProps> = ({
  clientId,
  contactOptions,
  loading,
  onChangeContactOptions,
  onSendDummy,
}) => (
  <Box>
    <SelectContactsToSendTo
      checkboxId="cc-user-send-item"
      checked={contactOptions.isUserCcedOnEmails}
      clientId={clientId}
      onChangeCheckbox={(isUserCcedOnEmails) =>
        onChangeContactOptions({ ...contactOptions, isUserCcedOnEmails })
      }
      onChangeSelect={(clientContactIds) =>
        onChangeContactOptions({ ...contactOptions, clientContactIds })
      }
      selectValue={contactOptions.clientContactIds}
    />

    <Divider marginY="space-24" />

    <Button
      icon="mail"
      isLoading={loading}
      onClick={onSendDummy}
      variant="inline-secondary"
    >
      {locales.sendToMyself}
    </Button>

    <Divider marginBottom="space-36" marginTop="space-26" />
  </Box>
);

export default ContactPicker;
